export default __webpack_public_path__ + "static/media/3.2ddc4a56.jpg";